import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlatformLocation } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class WpService {

  ROOT_ENDPOINT: string = 'https://'+this.platformLocation.hostname+'/wp-json/';
  private nonce: string = '';

  constructor(
    private http: HttpClient,
    private platformLocation: PlatformLocation
  ) {
    
  }

  public setNonce(nonce: string) : boolean {
    this.nonce = nonce;
    return true;
  }

  public loadCurrentUser() : Observable<any> {

    console.log(this.ROOT_ENDPOINT);

    const headers = new HttpHeaders({
      'X-WP-Nonce': this.nonce,
    });
    return this.http.get<any>(
      this.ROOT_ENDPOINT + 'wp/v2/users/me',
      { headers, withCredentials: true }
    )
  }
}
